import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-credit-card-check',
  templateUrl: './credit-card-check.component.html',
  styleUrls: ['./credit-card-check.component.css']
})
export class CreditCardCheckComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
